/**
 * Sets up vue component watch with single method handling for bulk properties.
 *
 * @since  2.0.0
 *
 * @param  {Array}  toWatch Array of props/computed/etc to watch.
 * @param  {string} method  The method in the methods property of the component to call.
 *
 * @returns {Object}         A watch object.
 */
export const bulkWatchHandler = (toWatch, method) => {
	const watch = {}
	toWatch.forEach(prop => {
		const func = new Function( // eslint-disable-line no-new-func
		     `return function ${prop}(newVal, oldVal){this.${method}(newVal, oldVal, '${prop}')}`
		)()
		watch[ prop ] = func
	})
	return watch
}

export const wpSetting = ({ setting, defaultValue, getter, setter, ...rest }) => {
	const key = `wp.post_meta._omapi_${setting}`
	function get () {
		const value = this.$get(`campaign.${key}`, defaultValue)
		return getter ? getter.call(this, value, key) : value
	}
	return {
		get,
		set (value) {
			value = setter ? setter.call(this, value, key, get.bind(this)) : value
			this.updateCampaignValue({
				campaignId : this.id,
				key,
				value,
				...rest,
			})
		},
	}
}
